import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const lookupService = {
    getLookupRoles, 
    getAllPermissions, 
    getLookupUsers,
    getLookupCompanies, 
    getLookupForms, 
    getLookupClasses, 
    getLookupMoas,
    getLookupTypes, 
    getLookupPurposes, 
    getLookupBrands,
    getLookupStatus,
    getLookupProducts,
    getLookupAIs,
    getLookupSources,
    getAllModulePermissions,
    getLookupProductCreateUpdates
};

const MODULE = {
    LOOKUP: 'lookup',
    ROLES: 'roles', 
    PERMISSIONS: 'permissions', 
    USERS: 'users', 
    COMPANIES: 'rnd-companies', 
    FORMS: 'rnd-forms', 
    CLASSES: 'rnd-classes', 
    MOAS: 'rnd-moas', 
    TYPES: 'rnd-types', 
    PURPOSES: 'rnd-purposes', 
    BRANDS: 'rnd-brands', 
    STATUS: 'rnd-status', 
    PRODUCTS: 'rnd-products', 
    AIS: 'rnd-ais', 
    SOURCES: 'rnd-sources', 
    PRODUCT_CREATE_UPDATES: 'rnd-product-create-updates', 
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'

export function getLookupRoles() {
    const requestOptions = {
      params: {
        is_active: 1
      }
    }
    return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.ROLES}`, requestOptions)
}

export function getAllPermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PERMISSIONS}`)
}

export function getLookupUsers() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.USERS}`)
}

export function getAllModulePermissions() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/rnd-module-permissions`)
}

export function getLookupCompanies() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.COMPANIES}`)
}

export function getLookupForms() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.FORMS}`)
}

export function getLookupClasses() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.CLASSES}`)
}

export function getLookupMoas() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.MOAS}`)
}

export function getLookupTypes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.TYPES}`)
}

export function getLookupPurposes() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PURPOSES}`)
}

export function getLookupBrands() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.BRANDS}`)
}

export function getLookupStatus() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.STATUS}`)
}

export async function getLookupProducts() {
  return await apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PRODUCTS}`)
}

export function getLookupAIs() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.AIS}`)
}

export function getLookupSources() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.SOURCES}`)
}

export function getLookupProductCreateUpdates() {
  return apiHelper(API_URL).get(`/${MODULE.LOOKUP}/${MODULE.PRODUCT_CREATE_UPDATES}`)
}
